import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get Observation.Search (Vitals) (R4) data from EHR
 * @param {*} patID 
 * @param {*} encodedFloID (Search by Code) 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationVitalsByCode(patFHIRID, encodedFloID, fhir_server, access_token) {
  const vitals = {};

  var date = new Date();
  date.setHours(date.getHours() - 4);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';

  var date2 = new Date();
  date2.setHours(date2.getHours() - 1);
  const isoStringWithoutMs2 = date2.toISOString().slice(0, 19) + 'Z';

  const ehrconfig = await axios.get('ehrconfig.json');
  let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
  let getObservationVitalsUrl = fhir_server + observationSearchUrl + '?code=' + encodedFloID + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs + '&date=le' + isoStringWithoutMs2;

  try {
    let response = await axios.get(
      getObservationVitalsUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    WriteToLog("getObservationVitalsByCode Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      for (var i= 0; i < entryArray.length; i++) {
        if (entryArray[i].resource !== undefined) {
          let resourceType = entryArray[i].resource.resourceType;
          if (resourceType === "Observation" && entryArray[i].resource.code !== undefined) {
            let code = entryArray[i].resource.code.text;
            WriteToLog("Code: " + code);
            if (code === "MAP" || code === "Arterial Line MAP") {
              if (entryArray[i].resource.valueQuantity !== undefined) {
                const floValue = {};
                floValue.value = entryArray[i].resource.valueQuantity.value;
                floValue.unit = entryArray[i].resource.valueQuantity.unit;
                floValue.timestamp = entryArray[i].resource.issued;
                //console.log("floValue: " + JSON.stringify(floValue));
                // Get the latest value from the top
                if(vitals[code] === undefined ) {
                  vitals[code] = floValue;
                }
              }
            } 
          }
        }
      }
      WriteToLog("getObservationVitalsByCode Observation.Search (R4) response: " + JSON.stringify(vitals));
      return vitals;
    } 
  } catch (error) {
    if (!error.message.includes("401")) { // 401 - Access Token Expired
      WriteToLog("getObservationVitalsByCode Observation.Search FHIR error: " + error.message);
    }
    return null;
  }
}

export default getObservationVitalsByCode;
